import { Navigate, useParams } from "../../../../../router-utils"

export default function OAuthIntegrationOverviewPage() {
	const { integrationId } = useParams("/integrations/:integrationId/oauth")

	return (
		<Navigate
			to="/integrations/:integrationId/oauth/setup"
			params={{ integrationId }}
			replace
		/>
	)
}
